export default {
  cta: "Let's start producing",
  title: "",
  leftTitle: "These are the main business rules.",
  leftSubtitle: "Review operations."
};
